module.exports = __webpack_public_path__ + "img/arch-2.87db7aa5.svg";